
import React, { Component, PureComponent } from "react";
import { PieChart, Pie, Sector, Cell, Legend, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { connect } from 'react-redux'
import { MESSAGE } from '../../../../constants/dictionaries'
import Helper from '../../../../helper/helper';
import Constant, { functionsCode, groupFunctionsCode } from '../../../../constants/constant';
import Message from "../../../../components/Messages";

//component

import { Table, Row, Col } from 'antd';
import message from "../../../../components/Messages";
import Api_tnn from '../../../../api/api.tnn';
import Api_quantrac from '../../../../api/api.quantrac'


class SoLieu extends Component {
    constructor(props) {
        super(props);
        const { functions } = props;
        this.state = {
            data: [],
            data_1: []
        }
    }
    componentDidMount() {
        this.getgp();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
    }
    getgp = async () => {
        try {
            const dataquantrac = await new Api_quantrac().tongso_gp({ token: this.props.user.access_token })
            if (dataquantrac) {
                this.setState({

                    data: [
                        // { name: '', tittle: "SỞ BAN NGÀNH KHÁC", value: dataquantrac ? dataquantrac.count_htmt_bcdk : "null", backGroundColor: '#5d9cec' },
                        { name: ' Thủy sản', tittle: "SỞ BAN NGÀNH KHÁC", value: dataquantrac ? dataquantrac.count_ntts_bcdk : 0, backGroundColor: '#656565b8' },
                        { name: 'Vịnh Hạ Long ', value: dataquantrac ? dataquantrac.count_qtvinhhalong_bcdk : 0, backGroundColor: '#d8b844' },
                    ],
                    data_1: [
                        { name: 'Tổng số', tittle: "ĐỀ NGHỊ CẬP NHẬT CẤP PHÉP", value: dataquantrac ? dataquantrac.count_denghecapnhatcp_tongso : 0 },
                        { name: 'Chờ xác nhận', value: dataquantrac.count_denghecapnhatcp_choxacnhan, backGroundColor: '#faad14' },
                        { name: 'Đã cập nhật', value: dataquantrac ? dataquantrac.count_denghecapnhatcp_dacapnhat : 0, backGroundColor: '#52c41a' },
                        { name: 'Đã trả lại', value: dataquantrac ? dataquantrac.count_denghecapnhatcp_datralai : 0, backGroundColor: '#f5222d' },
                    ]

                })
            }
        } catch (err) {
            message.error(err.message)
        }
    }
    handleClick = (name) => {
        const { functions } = this.props
        const groupFunctions = Helper.handleGroupFunctions(functions, groupFunctionsCode);
        if (name === "Tổng số") {


            groupFunctions[groupFunctionsCode.BCDN].includes(functionsCode.BCDN_CNCP) ?
                this.props.history.push('/BCDN/CNCP')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)

        }
        else if (name === 'Chờ xác nhận') {

            groupFunctions[groupFunctionsCode.BCDN].includes(functionsCode.BCDN_CNCP) ?
                this.props.history.push('/BCDN/CNCP?Column=&PageNumber=1&PageSize=10&Sort=DESC&StrSearch=&TrangThai=2')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        else if (name === 'Đã cập nhật') {
            groupFunctions[groupFunctionsCode.BCDN].includes(functionsCode.BCDN_CNCP) ?
                this.props.history.push('/BCDN/CNCP?Column=&PageNumber=1&PageSize=10&Sort=DESC&StrSearch=&TrangThai=3')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        else if (name === 'Đã trả lại') {
            groupFunctions[groupFunctionsCode.BCDN].includes(functionsCode.BCDN_CNCP) ?
                this.props.history.push('/BCDN/CNCP?Column=&PageNumber=1&PageSize=10&Sort=DESC&StrSearch=&TrangThai=4')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
    }


    render() {
        const { data, data_1 } = this.state
        const COLORS = ["#52c41a", '#faad14', '#f5222d', '#faad14', '#f4953f'];
        return (
            <Row style={{paddingBottom: data_1 && data_1.length > 0 && data_1[0].value !== 0 ? 0 : 55}}>
                <Col span={12}>
                    <div className="tieudetrangchu">
                        {data_1 && data_1.length > 0 && data_1[0].tittle}
                    </div>
                    <div >
                        {data_1 && data_1.length > 0 && data_1[0].value !== 0 ?

                            <div className="bieudosolieu" >
                                <PieChart width={200} height={165}>
                                    <Pie
                                        data={data_1}
                                        labelLine={false}
                                        label={this.renderCustomizedLabel}
                                        outerRadius={80}
                                        fill="#8884d8"
                                        legendType='circle'
                                    >
                                        {
                                            data_1.map((entry, index) => <Cell fill={COLORS[index % COLORS.length]} onClick={() => this.handleClick(entry.name)} />
                                            )
                                        }
                                    </Pie>
                                    <Tooltip />
                                </PieChart>
                            </div>
                            :
                            <div className="chuthich" style={{ paddingLeft: 10 }}>Chưa có dữ liệu</div>}
                        <div className="vr"></div>
                    </div>
                    <div className="chuthich" style={{ paddingLeft: 10 }}>
                        <div style={{ cursor: "pointer" }} onClick={() => this.handleClick(data_1[0].tittle_tong)}>
                            <Row >
                                <Col style={{ paddingLeft: 5 }}>
                                    {data_1 && data_1.length > 0 && data_1[0].value_tong
                                    }
                                </Col>
                            </Row>
                        </div>
                        {
                            data_1.map((item, index) => <div className="chuthichtitle"
                                onClick={() => this.handleClick(item.name)}
                            ><div className="titlechuthich" style={{ background: item.backGroundColor }} />{item.name + ": " + item.value}</div>
                            )

                        }
                    </div>

                </Col>

                <Col span={12} >
                    <div className="tieudetrangchu">
                        {data && data.length > 0 && data[0].tittle}
                    </div>

                    {data.map((item, index) =>
                        <div className="chuthich"  >{item.name + ": " + item.value}</div>)}
                </Col>

            </Row>



        );
    }
}




const mapStateToProps = (state) => ({
    user: state.oidc.user,
    functions: state.functions
});

export default connect(mapStateToProps)(SoLieu);